const french = {
    'STAFF_MANAGEMENT.Title_Point': "Point de pointage",
    'STAFF_MANAGEMENT.Title_Attendance': "Présences",
    'STAFF_MANAGEMENT.UseLocation': "Utiliser ma position",
    'STAFF_MANAGEMENT.SetPoint': "Définir le point de pointage",
    'STAFF_MANAGEMENT.SetPointHelp': "Placez-vous à l’endroit où les employés pointent leur arrivée, puis enregistrez votre position.",
    'STAFF_MANAGEMENT.CheckPin': "Vérifiez que c’est le bon endroit",
    'STAFF_MANAGEMENT.CheckSpot': "Vérifiez le repère, puis enregistrez",
    'STAFF_MANAGEMENT.Retake': "Reprendre",
    'STAFF_MANAGEMENT.Save': "Enregistrer",
    'STAFF_MANAGEMENT.Saving': "Enregistrement du point de pointage…",
    'STAFF_MANAGEMENT.Locating': "Nous affinons votre position. Restez au point de pointage — cela peut prendre jusqu’à 15 secondes.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Précision estimée : { accuracy } m",
    'STAFF_MANAGEMENT.LocationAccuracyUnknown': "Précision estimée indisponible",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Faible précision de localisation",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Vérifiez le point sur la carte ou relevez votre position à nouveau.",
    'STAFF_MANAGEMENT.LocationPermission': "Autorisez l’accès à votre position dans les paramètres du navigateur, puis réessayez.",
    'STAFF_MANAGEMENT.LocationTimeout': "Votre position n’a pas pu être déterminée à temps. Restez au point de pointage et réessayez.",
    'STAFF_MANAGEMENT.LocationUnavailable': "Votre position est indisponible. Vérifiez les paramètres de localisation de votre appareil et réessayez.",
    'STAFF_MANAGEMENT.MapUnavailable': "La carte n’a pas pu être chargée. Réessayez.",
    'STAFF_MANAGEMENT.Ready': "Prêt pour le pointage",
    'STAFF_MANAGEMENT.UpdateLocation': "Actualiser la position",
    'STAFF_MANAGEMENT.ViewQr': "Voir le code QR",
    'STAFF_MANAGEMENT.PointCreated': "Point de pointage créé",
    'STAFF_MANAGEMENT.PointUpdated': "Point de pointage mis à jour",
    'STAFF_MANAGEMENT.SaveError': "L’enregistrement n’a pas pu être confirmé. Vérifiez votre connexion et réessayez.",
    'STAFF_MANAGEMENT.NoManageAccess': "Vous n’avez pas l’autorisation de définir ou de modifier ce point de pointage.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "Vous n’avez pas l’autorisation de consulter les présences du personnel.",
    'STAFF_MANAGEMENT.SelectExhibition': "Sélectionnez d’abord un événement.",
    'STAFF_MANAGEMENT.Loading': "Chargement…",
    'STAFF_MANAGEMENT.Retry': "Réessayer",
    'STAFF_MANAGEMENT.Back': "Retour",
    'STAFF_MANAGEMENT.QrTitle': "Code QR de pointage",
    'STAFF_MANAGEMENT.QrMissing': "Aucun code QR de pointage n’est disponible pour le moment.",
    'STAFF_MANAGEMENT.QrError': "Le code QR n’a pas pu être chargé. Réessayez.",
    'STAFF_MANAGEMENT.DownloadPdf': "Télécharger le PDF",
    'STAFF_MANAGEMENT.PdfLoading': "Préparation du PDF…",
    'STAFF_MANAGEMENT.PdfError': "Le PDF n’a pas pu être créé. Réessayez.",
    'STAFF_MANAGEMENT.Today': "Aujourd’hui",
    'STAFF_MANAGEMENT.ChooseDate': "Choisir une date",
    'STAFF_MANAGEMENT.ChooseCompany': "Choisir une entreprise",
    'STAFF_MANAGEMENT.AllCompanies': "Toutes les entreprises",
    'STAFF_MANAGEMENT.Apply': "Appliquer",
    'STAFF_MANAGEMENT.NoCheckIn': "Aucune entrée enregistrée",
    'STAFF_MANAGEMENT.In': "Entrée",
    'STAFF_MANAGEMENT.Out': "Sortie",
    'STAFF_MANAGEMENT.Working': "Au travail",
    'STAFF_MANAGEMENT.Completed': "Terminé",
    'STAFF_MANAGEMENT.FailedCheckout': "Échec du pointage de sortie",
    'STAFF_MANAGEMENT.MissedCheckout': "Sortie non enregistrée",
    'STAFF_MANAGEMENT.UnknownStatus': "Statut inconnu",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "Aucun enregistrement de présence pour cette date.",
    'STAFF_MANAGEMENT.NoMatches': "Aucun employé ne correspond aux filtres sélectionnés.",
    'STAFF_MANAGEMENT.AttendanceError': "Les présences n’ont pas pu être chargées. Réessayez.",
    'STAFF_MANAGEMENT.UnknownCompany': "Entreprise non renseignée",
    'STAFF_MANAGEMENT.LoadPointError': "Le point de pointage n’a pas pu être chargé. Réessayez.",
    'STAFF_MANAGEMENT.PosterTitle': "Pointage d’entrée / de sortie",
    'STAFF_MANAGEMENT.PosterInstructions': "Ouvrez l’application ELFE et scannez ce code QR au début et à la fin de votre travail.",
    'STAFF_MANAGEMENT.PosterGenerated': "Code QR généré le : { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Prendre une photo',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Choisir dans la galerie',
    'CRAFT.Type_Logistics' : 'Logistique { number }',
    'CRAFT.Type_Floor' : 'Sol { number }',
    'CRAFT.Type_Assembly' : 'Montage { number }',
    'CRAFT.Type_Electrics' : 'Électricité { number }',
    'CRAFT.Type_Graphic' : 'Graphisme { number }',
    'CRAFT.Type_Furniture' : 'Mobilier { number }',
    'CRAFT.Type_Multimedia' : 'Multimédia { number }',
    'CRAFT.Type_Cleaning' : 'Nettoyage { number }',
    'CRAFT.Type_Additional' : 'Supplémentaire { number }',
    'CRAFT.Type_MPControl' : 'Contrôle MP',
    'CRAFT.Type_Protocol' : 'Protocole',
    'CRAFT.Type_Service' : 'Service { number }',
    'CRAFT.Type_CollectGraphics' : 'Collecte graphisme',
    'CRAFT.Status_Text_InProgress' : 'En cours',
    'CRAFT.Status_Text_Disabled' : 'Désactivé',
    'CRAFT.Status_Text_Completed' : 'Terminé',
    'CRAFT.Status_Text_Overdue' : 'En retard',
    'CRAFT.Status_Text_Done' : 'Collecté',
    'CRAFT.Status_Text_Open' : 'Ouvert',
    'CRAFT.Status_Text_Collected': 'Collecté',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Impossible de changer le statut : le graphisme a déjà été traité dans le panneau admin',
    'CRAFT.Button_ViewAll' : 'Voir tout',
    'CRAFT.Button_Text_Print' : 'Imprimer',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_Text_MarkOpen' : 'Marquer le lot ouvert',
    'CRAFT.Button_Text_MarkDone' : 'Marquer le lot terminé',
    'CRAFT.Button_Text_MarkInProgress' : 'Marquer le lot en cours',
    'CRAFT.Button_ChangeStatus_InProgress' : 'En cours',
    'CRAFT.Button_ChangeStatus_Done': 'Terminé',
    'CRAFT.Button_Text_ShelfNumber' : 'N° étagère',
    'CRAFT.Filter_Params_CraftType' : 'Lot : { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Veuillez sélectionner un salon { br } dans la liste ci-dessous',
    'EXHIBITION.Select_Label' : 'SALON SÉLECTIONNÉ',
    'EXHIBITION.Modal_Title' : 'CHOISIR UN SALON',
    'EXHIBITION.Timer_State_Underway' : 'EN COURS',
    'EXHIBITION.Timer_State_Ended' : 'TERMINÉ',
    'EXHIBITION.Title_CraftTotal' : 'Aperçu total des lots',
    'EXHIBITION.Statistic_Status_InTotal' : 'au total',
    'EXHIBITION.Statistic_Status_InProgress' : 'en cours',
    'EXHIBITION.Statistic_Status_Done' : 'terminé',
    'EXHIBITION.Statistic_Status_Overdue' : 'en retard',
    'EXHIBITION.Statistic_Status_NotApproved' : 'non approuvé',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'affectés au salon',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Pointés',
    'EXHIBITION.Statistic_Type_Stands' : 'Stands',
    'EXHIBITION.Statistic_Type_Claims' : 'Réclamations MP',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Réclamations exposant',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'Contrôle MP',
    'EXHIBITION.Statistic_Type_Damages' : 'Dommages',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protocole',
    'EXHIBITION.Statistic_Type_Staff' : 'Personnel',
    'FORM.Textarea_Placeholder_JobDescription' : 'Description de la tâche*',
    'FORM.Button_Text_AddJob' : 'Ajouter une tâche',
    'FORM.Button_Text_SaveJob' : 'Enregistrer la tâche',
    'FORM.Button_AddJobPhoto' : 'Ajouter une photo',
    'FORM_RULES.Required_Login' : 'Veuillez saisir votre identifiant',
    'FORM_RULES.Required_Password' : 'Veuillez saisir votre mot de passe',
    'FORM_RULES.Required_KeyDescription' : 'Veuillez saisir la description de la clé',
    'FORM_RULES.Required_KeyNumber' : 'Veuillez saisir le numéro de clé',
    'FORM_RULES.Required_JobDescription' : 'Veuillez ajouter une description de tâche',
    'FORM_RULES.Required_Quantity' : 'Veuillez saisir la quantité',
    'FORM_RULES.Min_Quantity' : 'La quantité doit être un nombre au moins égal à un',
    'FORMS.Input_Label_Login' : 'identifiant',
    'FORMS.Input_Label_Password' : 'mot de passe',
    'FORMS.Button_Text_Login' : 'Connexion',
    'FORMS.Input_Label_Description' : 'Description',
    'FORMS.Input_Label_KeyNumber' : 'Numéro de clé',
    'FORMS.Input_Label_Hall' : 'Hall',
    'FORMS.Input_Label_Stands' : 'Stands',
    'FORMS.Button_Text_ApplyFilters' : 'Appliquer',
    'FORMS.Button_Text_ResetFilters' : 'Réinitialiser les filtres',
    'FORMS.Select_DefaultValue_All' : 'Tous',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'Avec lots en cours',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Avec lots terminés',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'Avec contrôles en cours',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'Avec protocoles en cours',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'Avec lots en retard',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'Avec tâches supplémentaires',
    'FORMS.Button_Text_ApplySort' : 'Appliquer',
    'FORMS.Input_Label_CraftType' : 'Type de lot',
    'FORMS.Input_Label_JobType'   : 'Type',
    'FORMS.Input_Label_JobFlag'   : 'Drapeau',
    'FORMS.Input_Label_JobStatus' : 'Statut',
    'FORMS.Input_Label_CraftStatus' : 'Statut du lot',
    'FORMS.Input_Label_DamageStatus' : 'Statut des dommages',
    'FORMS.Input_Label_Subcontractor' : 'Sous-traitant',
    'FORMS.Input_Label_Comments' : 'Commentaires',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Tâches ouvertes',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Tâches en cours',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Tâches terminées',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Sans drapeau',
    'FORMS.Select_JobFlag_WithFlag' : 'Avec drapeau',
    'FORMS.Input_Label_FurnishingName' : 'Nom du mobilier',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Quantité',
    'FORMS.Input_Label_Quantity' : 'Quantité',
    'FORMS.Input_Label_CurrentQuantity' : 'Quantité actuelle',
    'FORMS.Input_Label_NewQuantity' : 'Nouvelle quantité',
    'FORMS.RadioInput_Text_Description' : 'Description',
    'FORMS.RadioInput_Text_Furnishing' : 'Mobilier',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Mobilier',
    'FORMS.Input_Label_OrderType'   : 'Type',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Retour d'article",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Perdu",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Modifier le total",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Commande",
    'GLOBAL.Button_Text_Logout' : 'Déconnexion',
    'GLOBAL.Button_Text_Filter' : 'Filtrer',
    'GLOBAL.Button_Text_Sort' : 'Trier',
    'GLOBAL.Text_Version' : 'Version { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Annuler',
    'ATTENDANCE.Button_CheckIn': 'Arrivée',
    'ATTENDANCE.Button_CheckOut': 'Départ',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Sélectionnez d’abord un salon.',
    'ATTENDANCE.Button_RetryScan': 'Scanner à nouveau',
    'ATTENDANCE.Button_Close': 'Fermer',
    'ATTENDANCE.Modal_Title_CheckIn': 'Scanner l’arrivée',
    'ATTENDANCE.Modal_Title_CheckOut': 'Scanner le départ',
    'ATTENDANCE.Scanner_Hint': 'Pointez la caméra vers le QR code',
    'ATTENDANCE.Processing_Locating_Title': 'Nous affinons votre position…',
    'ATTENDANCE.Processing_Locating_Text': 'Veuillez rester immobile. Cela peut prendre jusqu’à 15 secondes.',
    'ATTENDANCE.Processing_Submitting_Title': 'Envoi du scan...',
    'ATTENDANCE.Processing_Submitting_Text': 'Veuillez patienter. Enregistrement du temps de travail.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Accès à la localisation requis',
    'ATTENDANCE.Error_GpsPermission_Text': 'Autorisez l’accès à la localisation dans le navigateur et réessayez.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Signal GPS faible',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Les coordonnées sont introuvables. Rapprochez-vous de la sortie et scannez à nouveau.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS indisponible',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Les données de localisation ne sont pas disponibles sur cet appareil.',
    'ATTENDANCE.Error_Camera_Title': 'Caméra indisponible',
    'ATTENDANCE.Error_Camera_Text': 'Autorisez l’accès à la caméra et réessayez.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Accès à la caméra bloqué',
    'ATTENDANCE.Error_CameraPermission_Text': 'Autorisez l’accès à la caméra dans les paramètres du site du navigateur et réessayez.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Aucune caméra trouvée',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Cet appareil ne fournit aucune caméra disponible au navigateur.',
    'ATTENDANCE.Error_SecureContext_Title': 'HTTPS requis',
    'ATTENDANCE.Error_SecureContext_Text': 'La caméra et le GPS dans le navigateur mobile fonctionnent uniquement en HTTPS. Ouvrez l’application via un tunnel de développement HTTPS.',
    'ATTENDANCE.Error_Server_Title': 'Échec du scan',
    'ATTENDANCE.Error_Server_Text': 'Le serveur n’a pas pu traiter le scan. Vérifiez votre connexion Internet et réessayez.',
    'ATTENDANCE.Error_Generic_Title': 'Échec du scan',
    'ATTENDANCE.Error_Generic_Text': 'Veuillez réessayer.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Arrivée enregistrée',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Départ enregistré',
    'ATTENDANCE.Result_Accepted_Text': 'Heure : { serverTime }. Vous êtes enregistré dans le système.',
    'ATTENDANCE.Result_Duplicate_Title': 'Déjà enregistré',
    'ATTENDANCE.Result_Duplicate_Text': 'Ce scan a déjà été enregistré.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Arrivée enregistrée à un autre salon',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Pointez votre départ de cet autre salon avant de pointer votre arrivée ici. Si vous n’avez pas accès à ce salon, contactez votre responsable de chantier ou de projet.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'Service déjà clôturé',
    'ATTENDANCE.Link_MyTimeRecords': 'Voir mes relevés de temps',
    'ATTENDANCE.Result_ShiftClosed_Text': 'Votre service est déjà clôturé. Si vous n’avez pas pointé votre départ, un responsable l’a peut-être clôturé. Pour commencer un nouveau service, pointez votre arrivée.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Arrivée déjà enregistrée',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Pointez votre départ de ce salon avant de pointer à nouveau votre arrivée.',
    'ATTENDANCE.Result_Rejected_Title': 'Accès refusé',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Vous êtes trop loin de l’entrée. Rapprochez-vous de l’entrée.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Ce QR code n’est pas valide pour l’arrivée/le départ.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Le scan a été refusé.',
    'ATTENDANCE.Button_Back': 'Retour',
    'ATTENDANCE.Button_TryAgain': 'Réessayer',
    'ATTENDANCE.Button_GotIt': 'Compris',
    'ATTENDANCE.Overview_NotCheckedIn': 'Pas encore pointé',
    'ATTENDANCE.Overview_CheckInPrompt': 'Pointez en scannant le code QR',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Vous avez pointé',
    'ATTENDANCE.Overview_CheckedInAt': 'à { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Avant de commencer le travail, scannez le code QR pour pointer',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Pour terminer, visez le code QR de l’exposition',
    'ATTENDANCE.Error_StatusLoad_Text': 'Impossible de charger le statut de pointage.',
    'ATTENDANCE.Error_CameraDesign_Title': 'L’application ne peut pas ouvrir votre caméra',
    'ATTENDANCE.Error_CameraDesign_Text': 'Pour pointer, scannez le code avec la caméra du téléphone. Appuyez sur Réessayer et autorisez l’accès à la caméra.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Cela ne fonctionne toujours pas ? Vérifiez l’autorisation de la caméra dans le navigateur.',
    'ATTENDANCE.Error_LocationDesign_Title': 'L’application ne voit pas votre position',
    'ATTENDANCE.Error_LocationDesign_Text': 'Votre position est nécessaire pour confirmer votre présence. Activez-la dans les réglages, puis réessayez.',
    'ATTENDANCE.Result_CheckedInAt': 'Vous avez pointé le { date } à { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Vous avez bien pointé votre arrivée au travail à { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Vous avez terminé votre travail et{ br }pointé votre départ à { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Vous devez être sur le lieu de l’événement',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Votre position ne correspond pas à l’exposition. Les pointages utilisent le GPS. Réessayez au bon endroit.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Faible précision de localisation',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Précision : { accuracy } (Trop faible)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'Pour pointer votre arrivée :',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'Pour pointer votre départ :',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Activez « Position exacte » pour votre navigateur dans les réglages du téléphone',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Activez le Wi-Fi pour faciliter la localisation de votre appareil',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Appuyez ensuite sur { back } et scannez à nouveau le code.',
    'ATTENDANCE.Accuracy_Meters': '{ value } m',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } km',
    'ATTENDANCE.Result_InvalidQr_Title': 'Ce n’est pas le bon code',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Pointage d’entrée impossible !',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Pointage de sortie impossible !',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Ce code QR ne correspond pas à votre événement. Veuillez vous adresser à votre responsable de chantier ou de projet.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'Ce code QR n’est plus à jour. Veuillez scanner le code QR le plus récent.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Pointage d’entrée impossible !',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Une autre personne a déjà pointé son arrivée avec ce téléphone. L’application ne permet pas à deux utilisateurs différents de pointer leur arrivée avec le même appareil !',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Scan du pointage d’entrée impossible !',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Le pointage d’entrée n’est possible que pendant la période prévue pour l’événement. Veuillez vous adresser à votre responsable de chantier ou de projet.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Le pointage de sortie n’est pas disponible',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Cette action est disponible uniquement pendant la période configurée de l’exposition. Vérifiez l’exposition sélectionnée et ses dates.',
    'ATTENDANCE.TimeRecords_InProgress': 'en cours',
    'ATTENDANCE.TimeRecords_Missed': 'manqué',
    'ATTENDANCE.TimeRecords_Empty': 'Aucun relevé de temps.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Impossible de charger les relevés de temps.',
    'MENUS.Label_MyTimeRecords': 'Mes relevés de temps',
    'PAGE.Title_MyTimeRecords': 'Mes relevés de temps',
    'GLOBAL.Badge_Text_New' : 'NOUVEAU',
    'GLOBAL.Modal_Title_Filters' : 'Filtres',
    'GLOBAL.Modal_Title_SortBy' : 'Trier par',
    'GLOBAL.TimeLeft' : '{ timeLeft } restant',
    'GLOBAL.Text_Piece' : 'pcs',
    'GLOBAL.Button_Text_Confirm' : 'Confirmer',
    'GLOBAL.Language_Default' : 'Par défaut',
    'TRANSLATION.Button_Text_Translate' : 'Traduire',
    'TRANSLATION.Button_Text_TranslateInput' : 'Traduire en allemand',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Traduire en anglais',
    'TRANSLATION.Button_Text_TranslateNative' : 'Traduire dans ma langue',
    'TRANSLATION.Button_Text_ShowOriginal' : "Afficher l'allemand original",
    'TRANSLATION.Text_InputTranslating' : 'Traduction...',
    'TRANSLATION.Text_InputTranslated' : 'Traduit',
    'TRANSLATION.Text_InputTranslationError' : 'Échec de la traduction',
    'TRANSLATION.Text_InputTranslationRequired' : "Veuillez traduire le texte avant l'envoi",
    'TRANSLATION.Text_ApiUnavailable' : "La traduction n'est pas disponible pour le moment",
    'GLOBAL.Card_Hero_Hall' : 'Hall',
    'GLOBAL.Card_Hero_Block' : 'Bloc',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Commentaire',
    'HALL.Button_Text_HallPlan' : 'Plan du hall',
    'HALL.Link_Text_HallPlan' : 'Plan du hall { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hall',
    'JOB.Card_Hero_Number' : 'N° tâche',
    'JOB.Card_Hero_Block' : 'Bloc',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Exposant',
    'JOB.Button_Text_ToTheStand' : 'Aller au stand',
    'JOB.Text_Creator' : 'par { whoCreate } le { whenCreate }',
    'JOB.Text_InWork' : 'par { whoWork } le { whenWork }',
    'JOB.Text_Executor' : 'par { whoExecute } le { whenExecute }',
    'JOB.Text_DurationTime' : 'Durée : { time }',
    'JOB.Type_Claim' : 'Réclamation MP',
    'JOB.Type_AllClaims' : 'Réclamation',
    'JOB.Type_CustomerClaim' : 'Réclamation exposant',
    'JOB.Type_LastMinute' : 'Last minute',
    'JOB.Type_Damage' : 'Dommage',
    'JOB.Type_ProtocolDefect' : 'Défaut protocole',
    'JOB.Button_ChangeStatus_Waiting' : 'Prendre la tâche',
    'JOB.Button_ChangeStatus_InProgress' : 'Tâche en cours',
    'JOB.Button_ChangeStatus_Done' : 'Terminer la tâche',
    'JOB.Modal_Title_Photo' : 'Photo de la tâche',
    'JOB.Filter_Params_JobType' : 'Type : { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Lot : { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nouveau { jobType }',
    'JOB.Modal_Title_EditJob' : 'Modifier { jobType }',
    'JOB.Button_Text_AddClaim' : 'Ajouter une réclamation MP',
    'JOB.Button_Text_AddCustomerClaim' : 'Ajouter une réclamation exposant',
    'JOB.Button_Text_AddLastMinute' : 'Ajouter une tâche last minute',
    'JOB.Button_Text_AddDamage' : 'Ajouter une photo de dommage',
    'JOB.Button_Text_AddProtocolDefect' : 'Ajouter un défaut protocole',
    'DAMAGE.Card_Title' : 'Dommages de { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Dommages { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Non vérifié',
    'DAMAGE.Status_Label_Check' : 'Vérifié',
    'DAMAGE.Status_Label_DCheck' : 'Approuvé',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Photo',
    'DAMAGE.Button_Text_AddNote' : "AJOUTER UNE NOTE",
    'DAMAGE.Modal_Button_AddPhoto' : 'Ajouter une photo',
    'DAMAGE.Modal_Button_CreateReport' : 'Créer un rapport',
    'DAMAGE.Modal_Button_EditReport' : 'Modifier le rapport',
    'DAMAGE.AsCraft_label' : "Dommages",
    "DAMAGE.Button_Text_Open" : "Ouvrir",
    "STAND.Block_Title_Damages" : "Dommages",
    'MENUS.Label_Overview' : 'Aperçu',
    'MENUS.Label_Stands' : 'Stands',
    'MENUS.Label_Jobs' : 'Tâches',
    'MENUS.Label_ExpoPlan' : 'Plan expo',
    'MENUS.Label_More' : 'Plus',
    'MENUS.Label_SelectExhibition' : 'Sélectionner un salon',
    'MENUS.Label_CraftsOverview' : 'Aperçu des lots',
    'MENUS.Label_HallsOverview' : 'Aperçu des halls',
    'MENUS.Label_ViewDamages' : 'Voir les dommages',
    'MENUS.Label_Downloads' : 'Téléchargements',
    'MENUS.Label_Documents' : 'Documents',
    'MENUS.Label_FurnishingLeftovers' : 'Restes de mobilier',
    'MENUS.Label_HelpImprint' : 'Mentions légales',
    'MENUS.Label_CollectGraphics' : 'Collecte graphisme',
    'NO_DATA.Exhibitions' : "Vous n'avez encore aucun salon.",
    'NO_DATA.Documents' : "Le salon actuel n'a { br } encore aucun document.",
    'NO_DATA.Stands' : 'Aucun stand ne correspond { br } à la recherche',
    'NO_DATA.StandPhoto' : "Vous n'avez pas encore de photo du stand",
    'NO_DATA.DamagePhoto' : "Vous n'avez pas encore de photo des dommages { br } de ce stand",
    'NO_DATA.Stand_NoKeys' : "Ce stand n'a encore aucune clé",
    'NO_DATA.Stand_DoesNotExist' : "Ce stand n'existe pas",
    'NO_DATA.Subcontractor_Unsigned' : 'Non signé',
    'NO_DATA.Jobs' : 'Aucune tâche ne correspond { br } à la recherche',
    'NO_DATA.Damages' : 'Aucun dommage ne correspond { br } à la recherche',
    'NO_DATA.Hall' : "Ce hall n'existe pas",
    'NO_DATA.HallPlan' : "Nous n'avons pas trouvé de plan de ce hall",
    'NO_DATA.Furnishing_Storage' : "Ce salon n'a pas { br } de mobilier en stock",
    'NO_DATA.Furnishing_Orders' : "Ce salon n'a pas { br } de commandes de mobilier",
    'PAGE.Title_Overview' : 'Aperçu',
    'PAGE.Title_ExhibitionSelection' : 'Sélection du salon',
    'PAGE.Title_Stands' : 'Stands',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Commentaires du stand',
    'PAGE.Title_StandLog' : 'Journal du stand',
    'PAGE.Title_StandKeys' : 'Clés du stand',
    'PAGE.Title_ViewDamages' : 'Voir les dommages',
    'PAGE.Title_AdditionalMenu' : 'Menu supplémentaire',
    'PAGE.Title_Jobs' : 'Tâches',
    'PAGE.Title_ExpoPlan' : 'Plan expo',
    'PAGE.Title_Documents' : 'Documents',
    'PAGE.Title_FurnishingLeftovers' : 'Mobilier LM',
    'PAGE.Title_FurnishingReturns' : 'Journal des changements mobilier',
    'PAGE.Title_HallPlan' : 'Plan du hall',
    'PAGE.Title_HallsOverview' : 'Aperçu des halls',
    'PAGE.Title_CraftsOverview' : 'Aperçu des lots',
    'PAGE.Title_HelpImprint' : 'Mentions légales',
    'PAGE.Title_CollectGraphics' : 'Collecte graphisme',
    'SORT.Text_NewestByCreation' : 'Plus récent par date de création',
    'SORT.Text_OldestByCreation' : 'Plus ancien par date de création',
    'SORT.Text_ExhibitorNameAZ' : 'Nom exposant (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Nom exposant (Z-A)',
    'SORT.Text_FinishedFirst' : 'Terminés en premier',
    'SORT.Text_InProgressFirst' : 'Ouverts en premier',
    'SORT.Text_StandNumberAZ' : 'Numéro de stand (A-Z)',
    'SORT.Text_StandNumberZA' : 'Numéro de stand (Z-A)',
    'SORT.Text_CorridorAZ' : 'Couloir (A-Z)',
    'SORT.Text_CorridorZA' : 'Couloir (Z-A)',
    'SORT.Text_BlockAZ' : 'Bloc (A-Z)',
    'SORT.Text_BlockZA' : 'Bloc (Z-A)',
    'SORT.Text_FlagFirst' : 'Avec drapeau en premier',
    'SORT.Text_FlagLast' : 'Avec drapeau en dernier',
    'SORT.Text_HallAZ' : 'Hall (A-Z)',
    'SORT.Text_HallZA' : 'Hall (Z-A)',
    'SORT.Text_StatusAZ' : 'Approuvé',
    'SORT.Text_StatusZA' : 'Non vérifié',
    'STAND.Modal_Title_Search' : 'Recherche',
    'STAND.Input_Placeholder_Search' : 'Recherche',
    'STAND.Filter_Params_Exhibitor' : 'Exposant : { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Avec commentaires',
    'STAND.Card_Hero_Hall' : 'Hall',
    'STAND.Card_Hero_Block' : 'Bloc',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Heure de livraison',
    'STAND.Modal_Title_StandPlan' : 'Dessin du stand',
    'STAND.Modal_Button_StandPlan' : 'Dessin',
    'STAND.Card_Button_Details' : 'Détails { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Photo du stand',
    'STAND.Modal_Button_StandPhoto' : 'Photo',
    'STAND.Modal_Button_SavePhoto' : 'Enregistrer la photo',
    'STAND.Modal_Button_AddPhoto' : 'Ajouter une photo',
    'STAND.Button_Text_Comments' : 'Commentaires',
    'STAND.Button_Text_AddComment' : 'Ajouter un commentaire',
    'STAND.Modal_Title_AddComment' : 'Ajouter un commentaire',
    'STAND.Modal_Title_EditComment' : 'Modifier le commentaire',
    'STAND.Modal_Button_AddComment' : 'Ajouter',
    'STAND.Modal_Button_SaveComment' : 'Enregistrer',
    'STAND.Text_NoComments' : "Il n'y a pas encore de commentaires",
    'STAND.Text_AddFile' : 'Ajouter un fichier',
    'COMMENTS.Text_Uploading' : 'Téléchargement...',
    'STAND.Text_EditComment' : 'Modifier',
    'STAND.Text_DeleteComment' : 'Supprimer',
    'STAND.Text_CommentDraftError' : "Le brouillon du commentaire n'est pas encore prêt",
    'STAND.Block_Title_Overview' : 'Aperçu',
    'STAND.Block_Title_Materials' : 'Informations supplémentaires',
    'STAND.Block_Title_Crafts' : 'Lots',
    'STAND.Block_ItemTitle_Hall' : 'Hall',
    'STAND.Block_ItemTitle_Block' : 'Bloc',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Numéro Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Tâches',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } en cours',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } ouvertes',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } terminées',
    'STAND.Block_Button_ViewStandJobs' : 'Voir les tâches du stand',
    'STAND.Modal_Title_StandGraphic' : 'Graphisme du stand',
    'STAND.Modal_Button_StandGraphic' : 'Graphisme du stand',
    'STAND.Modal_Title_ExtraInfo' : 'Infos supplémentaires',
    'STAND.Modal_Button_ExtraInfo' : 'Infos supplémentaires',
    'STAND.Button_Text_ViewKeys' : 'Voir les clés',
    'STAND.Button_Text_ViewLogs' : 'Voir les journaux',
    'STAND.Modal_Button_AddKey' : 'Ajouter une clé',
    'STAND.Modal_Title_AddKey' : 'Ajouter une clé',
    'STAND.Modal_Title_EditKey' : 'Modifier la clé',
    'STAND.Modal_Button_UpdateKey' : 'Mettre à jour la clé',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Supprimer',
    'STAND.Text_ModalDelete_Question' : 'Voulez-vous vraiment supprimer la clé { keyName } ?',
    'STAND.External_Exhibition' : "Salon auquel vous n'êtes pas assigné",
    'JOB.Button_Text_ViewPhoto' : 'Voir la photo',
    'OVERVIEW_TYPES.Label_InTotal' : 'au total',
    'OVERVIEW_TYPES.Label_Finished' : 'terminés',
    'OVERVIEW_TYPES.Label_Open' : 'ouverts',
    'OVERVIEW_TYPES.Label_Claims' : 'réclamations',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'en retard',
    'FURNISHING.TabName_Storage' : 'Stock',
    'FURNISHING.TabName_Refund' : 'Retours',
    'FURNISHING.TabName_OrderLog' : 'Journal des commandes',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Quantités équipement LM',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Mobilier en stock',
    'FURNISHING.Button_Text_Return' : 'Retour',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Choisir le mobilier',
    'FURNISHING.Modal_Title_Photo' : "Photo du mobilier",
    'FURNISHING.Order_Type_Refund' : "Retour",
    'FURNISHING.Order_Type_Lost' : "Perdu",
    'FURNISHING.Order_Type_Correction' : "Correction",
    'FURNISHING.Order_Type_Order' : "Commande",
};

export default french;
